import React from 'react'
import { Option, Override, useDesignLanguagePerClass } from '@afterpaytouch/core'
import { useTranslation } from 'next-i18next'

import styles from './style.module.css'
import { useSelectedPreferredDay, useAppRouter, useIsHidePaymentDay } from '../../state'
import { getLocaleKeyFromDayNumber } from '../../utils/calendar'
import { TrackOnMount, useMonitoringWithEnduringEventProperties } from '../../integrations/monitoring'
import { TrackingEvent } from '../../model/monitoring'
import { Route } from '../../config/router'

export const PaymentDay = (): JSX.Element | null => {
  const { t } = useTranslation()
  const selectedPreferredDay = useSelectedPreferredDay()
  const designLanguageStyles = useDesignLanguagePerClass(styles)
  const { logEvent } = useMonitoringWithEnduringEventProperties()
  const router = useAppRouter()
  const hidePaymentDay = useIsHidePaymentDay()

  const handleOnClick = (): void => {
    logEvent(TrackingEvent.PRESSED_SUMMARY_PAGE_ALIGN_PAYMENTS_TAB)
    router.push(Route.PREFERRED_PAYMENT_DAY)
  }

  if (hidePaymentDay) {
    return null
  }

  return (
    <div className={designLanguageStyles.container}>
      <Option
        text={t(getLocaleKeyFromDayNumber(selectedPreferredDay))}
        floatingHeader={t('preferredDay.title')}
        onClick={handleOnClick}
        override={Override.DisabledBorderRadius}
        testNameSpace={'preferred-payment-day'}
      />
      <TrackOnMount eventName={TrackingEvent.VIEWED_ALIGN_PAYMENT_MESSAGE} />
    </div>
  )
}
